/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'documentoDetalle.CodigoBarras': 'Código de Barras',
    'documentoDetalle.DescripcionDivisionDestino': 'División Destino',
    'documentoDetalle.FechaVencimiento': 'Fecha Vencimiento',
    'documentoDetalle.serial': 'Serial',
    'documentoDetalle.lote': 'Lote',
    'documentoDetalle.cantidadRecibida': 'Cantidad Recibida',
    'documentoDetalle.fechaVencimiento': 'Fecha Vencimiento',
    'documentoDetalle.producto': 'Producto',
    'documentoDetalle.divisionDestino': 'Division Destino',
    'documentoDetalle.cantidadSolicitada': 'Cantidad Solicitada ',
    'cardDocumentoDetalle.Busqueda': 'Buscar',
};
